define([
  "marionette",
  "jquery",
  "./template/topicResponseSourceModalTemplate.html",
  "jquery-ui",
  "jquery-ui/ui/widgets/tabs",
], function (Marionette, $, TopicResponseSourceModalTemplate) {
  "use strict";
  return {
    topicResponseSourceModalView: Marionette.ItemView.extend({
      template: TopicResponseSourceModalTemplate,
      className: "response-source",
    }),
  };
});
